/**
 * Time 命名空间
 * 用于时间相关的 trigger 类型前缀
 */
export const timeNamespace = 'fanfanlo/javajs/v1/project/components/triggers/time/'
